import { Component, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/user/account.service';
import { NgClass } from '../../../../../../node_modules/@angular/common/index';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-bajaj-prime-modal',
  templateUrl: './bajaj-prime-modal.component.html',
  styleUrls: ['./bajaj-prime-modal.component.scss'],
})
export class BajajPrimeModalComponent {
  @Output() joinPrime = new EventEmitter<void>();
  @Output() continueBooking = new EventEmitter<void>();

  isPrimeEnabled: boolean;

  constructor(
    private modalController: ModalController,
    private accountService: AccountService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.isPrimeEnabled = this.accountService.isPrimeUserType();
  }

  onJoinPrime() {
    this.joinPrime.emit();
    this.dismiss('join');
    this.analyticsService.trackUnified('join_prime_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Join Prime Button Clicked',
      button: 'join-prime-button',
    });
  }

  onContinueBooking() {
    this.continueBooking.emit();
    this.dismiss('continue');
    this.analyticsService.trackUnified('continue_booking_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Continue Booking Button Clicked',
      button: 'continue-booking-button',
    });
}

  dismiss(action?: string) {
    this.modalController.dismiss({
      action: action,
    });
  }
}
